import { render, staticRenderFns } from "./type-modal-form.vue?vue&type=template&id=56ef342f&scoped=true&"
import script from "./type-modal-form.vue?vue&type=script&lang=js&"
export * from "./type-modal-form.vue?vue&type=script&lang=js&"
import style0 from "./type-modal-form.vue?vue&type=style&index=0&id=56ef342f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ef342f",
  null
  
)

export default component.exports